import React from 'react';
import { rem } from 'polished';
import Img from 'react-image';
import Loader from 'oxyrion-ui/lib/Loader';
import styled from 'styled-components';
import { __, formatBytes } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseMarketingLayout from '../BaseList';
import IconTd from '../../../Components/ReusableComponents/IconTd';
import PopUpWrapper from '../../../Components/PopUpWrapper';
import pdf from './images/pdf.png';
import eps from './images/eps.png';
import AlertPopup from '../../../Components/AlertPopup';
import FileViewDownload from '../../../Components/FileViewDownload';
import API2 from '../../../API2';

const ImageWrapper = styled.div`
  height: ${rem(120)};
  padding: ${rem(8)};
  margin-right: ${rem(16)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const P = styled.p`
  margin: 0;
  height: ${rem(120)};
  cursor: default;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  display: flex;
  align-items: center;
`;

const Image = styled(Img)`
  max-width: ${rem(180)};
  max-height: ${rem(100)};
  z-index: 2;
`;

const DetailImage = styled(Img)``;

const DetailImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  cursor: default;
  align-items: center;
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

const images = [
  {
    type: 'application/pdf',
    path: pdf,
  },
  {
    type: 'application/postscript',
    path: eps,
  },
];

class Graphic extends BaseMarketingLayout {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Grafika'),
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      isProduct: false,
      defaultFilter: [
        {
          id: 'type',
          values: ['Grafika'],
        },
      ],
    };

    actions.setActiveMenuItem('82');
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
    } = this.loadActualData();
    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(false);
        this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (!checkedFilter.find(c => c.id === 'type')) {
        checkedFilter.concat(this.state.defaultFilter);
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      params.type = 'graphic';

      const newData = await API2.getB2BMultimediaAction(
        Object.assign(params, { limit }),
      );

      this.setState({
        tableItems: newData.multimedia,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  async downloadFile(id) {
    try {
      const result = await API2.getB2BMultimediaDownloadAction(id);

      this.setState({
        downloadId: result.url,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadId: undefined,
    });
  }

  showImageDetail(fullPath) {
    this.setState({
      imageDetailFullPath: fullPath,
    });
  }

  getPlaceholderByType(type) {
    if (!type) {
      return null;
    }

    if (images.find(i => i.type === type)) {
      return images.find(i => i.type === type).path;
    }

    return null;
  }

  createColumns(sorter) {
    const result = [
      {
        accessor: 'file',
        Header: () => <IconTd>{__('Náhľad')}</IconTd>,
        Cell: props => {
          return (
            <ImageWrapper
              onClick={() => this.showImageDetail(props.value.fullPath)}
            >
              <Image
                src={[
                  `${baseURL}/images/270x0/${props.original.view_image &&
                    props.original.view_image.fullPath}`,
                  `${baseURL}/images/270x0/${props.value &&
                    props.value.fullPath}`,
                  this.getPlaceholderByType(
                    props.value && props.value.mimeType,
                  ),
                ]}
                loader={<Loader color="#70af00" />}
              />
            </ImageWrapper>
          );
        },
      },
      {
        accessor: 'name',
        Header: () => <IconTd>{__('Názov súboru')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'file',
        Header: () => <IconTd>{__('Formát')}</IconTd>,
        Cell: props => {
          return <P>{props.value && props.value.name.split('.').pop()}</P>;
        },
      },
      {
        accessor: 'file',
        Header: () => <IconTd>{__('Veľkosť')}</IconTd>,
        Cell: props => {
          return <P>{props.value && formatBytes(props.value.size)}</P>;
        },
      },
      {
        accessor: 'file',
        Header: () => <IconTd>{__('Zobraziť / Stiahnuť')}</IconTd>,
        Cell: props => {
          return (
            <P>
              <FileViewDownload
                name={props.value.name}
                type={props.value.mimeType}
                fullPath={props.value.fullPath}
                history={this.props.history}
                downloadFunction={async () => {
                  return API2.getB2BMultimediaDownloadAction(
                    props.original._id,
                    {
                      type: 'pdf',
                    },
                  );
                }}
                error={error => {
                  this.setState({ error });
                }}
              />
            </P>
          );
        },
      },
    ];

    return result;
  }

  openMarketingMaterial(id) {
    this.props.history.push(`/marketing/materials/${id}`);
  }

  render() {
    const { imageDetailFullPath, downloadId } = this.state;
    return (
      <React.Fragment>
        <AlertPopup
          alignUnderHeader
          display={downloadId}
          style
          onClose={() =>
            this.setState({
              downloadId: undefined,
            })
          }
          scrollContent
          question
          text={__(`Prajete si uložiť súbor`)}
          onSubmit={() => this.downloadFileWithId(downloadId)}
          onDismiss={() =>
            this.setState({
              downloadId: undefined,
            })
          }
        />

        <PopUpWrapper
          customWidth={900}
          display={imageDetailFullPath}
          message={__('Detail grafiky')}
          onClose={() =>
            this.setState({
              imageDetailFullPath: undefined,
            })
          }
          onEscClose={() =>
            this.setState({
              imageDetailFullPath: undefined,
            })
          }
        >
          <DetailImageWrapper>
            <DetailImage
              src={[`${baseURL}/images/888x0/${imageDetailFullPath}`]}
              loader={<Loader color="#70af00" />}
            />
          </DetailImageWrapper>
        </PopUpWrapper>

        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Graphic);



// WEBPACK FOOTER //
// ./src/Containers/Marketing/Graphic/index.jsx